import React from 'react';
import { Modal } from 'react-bootstrap';

function PopUpModal(props) {
    let { content, show, closeModal } = props;

    return (
        <Modal size="sm" show={show} onHide={closeModal} aria-labelledby="example-modal-sizes-title-sm" centered className="common-modal">
            <Modal.Body>{content}</Modal.Body>
        </Modal>
    );
}

export default PopUpModal;
